import crypto from 'crypto'

function uuidv4() {
  return crypto.randomBytes(8).toString('hex')
}

export default uuidv4
